// 외부 서비스 URL
export const SCHOOL_URL = "https://school.smilebogun.org";
export const SCHOOL_SIGNUP_URL = "https://school.smilebogun.org/email-auth/";
export const COMPANY_URL = "https://company.smilebogun.org";
export const ADMIN_PAYMENT_URL = "https://smilebogun.com";
export const PRIVACY_DOC_URL =
  "https://smilebogun.org/doc/스마일보건_개인정보_문서.zip";

// 키오스크 영상 URL
export const KIOSK_VIDEO_LIVE_USE =
  "https://www.smilebogun.co.kr/videos/kiosk_live_use.mp4";
export const KIOSK_VIDEO_MEET_TEACHER =
  "https://www.smilebogun.co.kr/videos/kiosk_meet_teacher.mp4";
export const KIOSK_VIDEO_SELF_TREATMENT =
  "https://www.smilebogun.co.kr/videos/kiosk_self_treatment.mp4";

// 회사 이메일
export const COMPANY_EMAIL = "help@smilebogun.com";

// 배너 이미지 base URL
export const BANNER_IMAGE_BASE_URL = "https://www.smilebogun.org/slogo";
